var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.valor>0)?_c('div',{staticClass:"contador_numero font-weight-bold"},[_c('animated-number',{attrs:{"value":_vm.valor,"formatValue":_vm.formatoConteo,"duration":_vm.duracion}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contador_descripcion font-weight-medium",domProps:{"textContent":_vm._s(_vm.descripcion)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fe51ec4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inicio/Contador.vue
// module id = null
// module chunks = 